import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class MotorvehiclesService {
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/MotorVehicles/';

  insertvehicle(data) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertvehicle', data)
  }

  getmotorvehicle(id) {
    debugger
    return this.http.get(this.apiUrl + 'getvehicles?id='+id)
  }
  getmotorvehicleLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'getvehiclesLY?id=' + id)
  }

  getTangableData(id) {
    debugger
    return this.http.get(this.apiUrl + 'gettangable?id=' + id)
  }
}
